import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const Label = /*#__PURE__*/React.forwardRef(
/**
 * Label component
 * @param {Object} props
 * @param {any} props.children
 * @param {any} [props.className]
 * @param {boolean} [props.check]
 * @param {boolean} [props.radio]
 * @param {boolean} [props.disabled]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Label({
  children,
  check,
  radio,
  disabled,
  className,
  ...props
}, ref) {
  const checkClasses = "inline-flex items-center";
  const disabledClasses = "opacity-50 cursor-not-allowed";
  const labelClasses = classNames(["block text-sm text-gray-900"],
  // check and radio are interchangeable
  (check || radio) && checkClasses, disabled && disabledClasses, className);
  return /*#__PURE__*/React.createElement("label", _extends({
    className: labelClasses,
    ref: ref
  }, props), children);
});
Label.propTypes = {
  children: PropTypes.any,
  check: PropTypes.bool,
  radio: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};